export default "__VITE_ASSET__DILfZZ$9__"